export default {

  methods: {

    async set_LocalValues(){

      // this.db_Diagram    = JSON.parse(JSON.stringify(this.DataItems))
      // this.db_Stage      = JSON.parse(JSON.stringify(this.Queries.SQL1))
      // this.db_Table      = JSON.parse(JSON.stringify(this.Queries.SQL2))
      // this.db_Navigation = JSON.parse(JSON.stringify(this.Queries.SQL3))
      // this.db_Service    = JSON.parse(JSON.stringify(this.Queries.SQL4))

      this.winProps = {status: 'closed', width: this.Canvas.CanvasWidth, height: this.Canvas.CanvasHeight,}
      this.service = {}

      // JSON
      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.config       = json.config
      this.phase        = json.phase
      this.database     = json.database
      this.dataSource   = json.dataSource
      this.prequency    = json.prequency
      
      
      await this.stg_Select()
      this.db_Stage = this.cbData.data

      await this.tbl_Select()
      this.db_Table = this.cbData.data

      await this.nav_Select()
      this.db_Navigation = this.cbData.data

      await this.svc_Select()
      this.db_Service = this.cbData.data

      await this.dia_Select()
      this.db_Diagram = this.cbData.data
      this.set_Canvas() // -----> set_Canvas.js

    },
  }
}